<app-sidenav>
  <ng-template #sidenavContent>
    <app-services-side-cards [companyName]="companyName"></app-services-side-cards>
  </ng-template>

  <ng-template #mainContent>
    <h1 class="content-main-title">{{ 'content.main-heading' | translate }}</h1>
    <div class="d-flex justify-content-end">{{ 'content.all.required-field-explanation' | translate }}</div>
    <mat-horizontal-stepper #stepper [linear]="true">
      <mat-step #step1 [completed]="false">
        <ng-template matStepLabel>{{ 'content.info-about-order' | translate }}</ng-template>
        <form [formGroup]="serviceForm" [ngClass]="{'form-submitted': serviceFormSubmitted}" (submit)="submitBusinessServiceForm(serviceForm.value)">
          <h2>{{ 'content.choose-service' | translate }}</h2>
          <div class="form-row">
            <div class="form-group col-md-6 col-sm-12">
              <label for="choose-service-input">{{ 'content.service' | translate }}: *
                <select id="choose-service-input" class="form-select" formControlName="serviceType" #serviceTypeInput>
                  <option selected value="">{{ 'content.select-one' | translate }}</option>
                  @for (branchName of branchNames; track branchName) {
                    <option value="{{ branchName }}">{{ branchName }}</option>
                  }
                </select>
                <app-validation-errors [displayErrors]="serviceFormSubmitted" [errors]="c.serviceType.errors" [element]="serviceTypeInput"></app-validation-errors>
              </label>
            </div>
          </div>
          <h2>{{ 'content.info-about-order' | translate }}</h2>
          <div class="row">
            <div class="form-group col-md-6 col-sm-12 pe-2">
              <ng-template #productTypeTooltip>{{ 'content.product-type-change-explanation' | translate }}</ng-template>
              <label for="product-type-input">{{ 'content.product-type' | translate }}: *
                <fa-icon [icon]="faQuestionCircle" [ngbTooltip]="productTypeTooltip"></fa-icon>
                <select id="product-type-input" class="form-select" formControlName="productType" #productTypeInput>
                  <option selected value="">{{ 'content.select-one' | translate }}</option>
                  @for (productType of productTypes; track productType) {
                    <option value="{{ productType.code }}">{{ productType.desc }}</option>
                  }
                </select>
              </label>
              <app-validation-errors [displayErrors]="serviceFormSubmitted" [errors]="c.productType.errors" [element]="productTypeInput"></app-validation-errors>
            </div>
            <div class="form-group col-md-6 col-sm-12">
              <label for="reference-id-input">
                {{ 'content.reference-id' | translate }}:
                <app-required [control]="c.referenceId"></app-required>
                <input id="reference-id-input" class="form-control" type="text" autocomplete="on" formControlName="referenceId" #referenceIdInput>
              </label>
              <app-validation-errors [displayErrors]="serviceFormSubmitted" [errors]="c.referenceId.errors" [element]="referenceIdInput"></app-validation-errors>
            </div>
            @if (!!searchTypes) {
              <div class="form-group col-md-3 col-sm-6">
                <label for="search-type-input">{{ 'content.search-type' | translate }}: *
                  <select id="search-type-input" class="form-select" formControlName="searchType" #searchTypeInput>
                    <option selected value="">{{ 'content.select-one' | translate }}</option>
                    @for (searchType of (searchTypes | keyvalue); track searchType) {
                      <option value="{{ searchType.key }}">{{ searchType.value }}</option>
                    }
                  </select>
                </label>
                <app-validation-errors [displayErrors]="serviceFormSubmitted" [errors]="c.searchType.errors" [element]="searchTypeInput"></app-validation-errors>
              </div>
            }
          </div>
          @if (addonProducts && addonProducts.length > 0) {
            <div>
              <h3>{{ 'content.add-on-prod' | translate }}:</h3>
              @for (addon of addonProducts; track addon) {
                <div class="row">
                  <div class="form-group col-md-12 col-sm-12 row align-items-center"
                    [formGroup]="addonsGroup" role="radiogroup" [attr.aria-label]="'aria.request-add-on-addon' | translate:{addon:addon}">
                    <div class="ps-3 pe-3 pt-2 pb-2 col-6">{{ addon.desc }}:</div>
                    <div class="form-inline col-1">
                      <label class="form-check-label">
                        <input class="form-check-input" type="radio" [attr.name]="addon.code" [formControlName]="addon.code" value="y" (change)="selectedAddon()">
                        {{ 'content.yes' | translate }}
                      </label>
                    </div>
                    <div class="form-inline col-1">
                      <label class="form-check-label ms-2">
                        <input class="form-check-input" type="radio" [attr.name]="addon.code" [formControlName]="addon.code" value="n" (change)="unSelectedAddon()">
                        {{ 'content.no' | translate }}
                      </label>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
          <ng-template #businessTemplate>
            <h3>{{ 'content.business-name' | translate }}</h3>
            <div class="row ms-0 me-0">
              <div class="form-group col-md-6 col-sm-12 pe-2">
                <label>{{ 'content.business-operating-name' | translate }}:
                  <app-required [control]="c.businessOperatingName"></app-required>
                  <input class="form-control" type="text" autocomplete="on" formControlName="businessOperatingName" #businessOperatingNameInput>
                </label>
                <app-validation-errors [displayErrors]="serviceFormSubmitted" [errors]="c.businessOperatingName.errors" [element]="businessOperatingNameInput"></app-validation-errors>
              </div>
              <div class="form-group col-md-6 col-sm-12">
                <label>{{ 'content.business-legal-name' | translate }}:
                  <app-required [control]="c.businessLegalName"></app-required>
                  <input class="form-control" type="text" autocomplete="on" formControlName="businessLegalName" #businessLegalNameInput>
                </label>
                <app-validation-errors [displayErrors]="serviceFormSubmitted" [errors]="c.businessLegalName.errors" [element]="businessLegalNameInput"></app-validation-errors>
              </div>
              <div class="form-group col-md-6 col-sm-12 pe-2">
                <label>{{ 'content.business-reg-num' | translate }}:
                  <app-required [control]="c.businessRegistrationNum"></app-required>
                  <input class="form-control" type="text" autocomplete="on" formControlName="businessRegistrationNum" #businessRegistrationNumInput>
                </label>
                <app-validation-errors [displayErrors]="serviceFormSubmitted" [errors]="c.businessRegistrationNum.errors" [element]="businessRegistrationNumInput"></app-validation-errors>
              </div>
              @if (c.confirmationSearchNum) {
                <div class="form-group col-md-6 col-sm-12">
                  <label>{{ 'content.confirmation-search-num' | translate }}:
                    <app-required [control]="c.confirmationSearchNum"></app-required>
                    <input class="form-control" type="text" autocomplete="on" formControlName="confirmationSearchNum" #confirmationSearchNumInput>
                  </label>
                  <app-validation-errors [displayErrors]="serviceFormSubmitted" [errors]="c.confirmationSearchNum.errors" [element]="confirmationSearchNumInput"></app-validation-errors>
                </div>
              }
              <div class="form-group col-md-3 col-sm-6">
                <label>{{ 'content.qualifier' | translate }}:
                  <app-required [control]="c.qualifier"></app-required>
                  <select class="form-select" formControlName="qualifier" #qualifierInput>
                    @for (qualifier of qualifiers | keyvalue: asIsOrder; track qualifier) {
                      <option value="{{ qualifier.key }}">{{ qualifier.value }}</option>
                    }
                  </select>
                </label>
                <app-validation-errors [displayErrors]="serviceFormSubmitted" [errors]="c.qualifier.errors" [element]="qualifierInput"></app-validation-errors>
              </div>
            </div>
            <h3>{{ 'content.business-address' | translate }}</h3>
            <div class="row ms-0 me-0">
              <div class="form-group col-md-6 col-sm-12 pe-2">
                <label>{{ 'content.address.street-name' | translate }}:
                  <app-required [control]="c.streetName"></app-required>
                  <input class="form-control" type="text" autocomplete="on" formControlName="streetName" #streetNameInput>
                </label>
                <app-validation-errors [displayErrors]="serviceFormSubmitted" [errors]="c.streetName.errors" [element]="streetNameInput"></app-validation-errors>
              </div>
              <div class="form-group col-md-6 col-sm-12">
                <label>{{ 'content.address.city' | translate }}:
                  <app-required [control]="c.city"></app-required>
                  <input class="form-control" type="text" autocomplete="on" formControlName="city" #cityInput>
                </label>
                <app-validation-errors [displayErrors]="serviceFormSubmitted" [errors]="c.city.errors" [element]="cityInput"></app-validation-errors>
              </div>
              <div class="form-group col-md-6 col-sm-12 pe-2">
                <label>{{ 'content.address.province' | translate }}:
                  <app-required [control]="c.province"></app-required>
                  <select class="form-select" formControlName="province" #provinceInput>
                    <option value=""></option>
                    @for (province of provinceNames | keyvalue; track province) {
                      <option value="{{ province.key }}">{{ province.value }}</option>
                    }
                  </select>
                </label>
                <app-validation-errors [displayErrors]="serviceFormSubmitted" [errors]="c.province.errors" [element]="provinceInput"></app-validation-errors>
              </div>
              <div class="form-group col-md-3 col-sm-6">
                <label>{{ 'content.address.postal-code' | translate }}:
                  <app-required [control]="c.postalCode"></app-required>
                  <input class="form-control" type="text" autocomplete="on" formControlName="postalCode" mask="S0S-0S0" #postalCodeInput>
                </label>
                <app-validation-errors [displayErrors]="serviceFormSubmitted" [errors]="c.postalCode.errors" [element]="postalCodeInput"></app-validation-errors>
              </div>
              <div class="form-group col-md-4 col-sm-8">
                <label>{{ 'content.business-phone' | translate }}:
                  <app-required [control]="c.businessTelephoneNumber"></app-required>
                  <input class="form-control" type="tel" autocomplete="on" formControlName="businessTelephoneNumber" mask="(000) 000-0000" #businessTelephoneNumberInput>
                </label>
                <app-validation-errors [displayErrors]="serviceFormSubmitted" [errors]="c.businessTelephoneNumber.errors" [element]="businessTelephoneNumberInput"></app-validation-errors>
              </div>
            </div>
            <div class="d-flex justify-content-end inline-gap-5 submit-buttons mb-2 me-1">
              <button type="button" class="tu-button secondary tu-shadow" (click)="cancel()">{{ 'content.cancel' | translate }}</button>
              <button class="tu-button primary tu-shadow" type="submit">{{ 'content.next' | translate }}</button>
            </div>
          </ng-template>
          <h2>{{ 'content.business-report' | translate }}</h2>
          @if (!ownerTabEnabled) {
            <div>
              <ng-container *ngTemplateOutlet='businessTemplate'></ng-container>
            </div>
          }
          @if (ownerTabEnabled) {
            <div>
              <ul #nav="ngbNav" ngbNav role="tablist" class="tu-nav-tabbar nav nav-pills" [roles]="false" [destroyOnHide]="false" [(activeId)]="active">
                <!-- Business Details tab -->
                <li role="tab" [ngbNavItem]="-2">
                  <a ngbNavLink appAriaAttrsParent><div [ngClass]="businessTabError ? 'tab-error' : 'tab-custom'">{{ 'content.business-tab' | translate }}</div></a>
                  <ng-template ngbNavContent>
                    <ng-container *ngTemplateOutlet='businessTemplate'></ng-container>
                  </ng-template>
                </li>
                <!-- Owner Details tab -->
                <li role="tab" [ngbNavItem]="-1">
                  <a ngbNavLink appAriaAttrsParent><div [ngClass]="ownerStaticTabError ? 'tab-error' : 'tab-custom'">{{ 'content.owner-tab' | translate }} {{ 1 }} </div></a>
                  <ng-template ngbNavContent>
                    <app-owner-profile formControlName="profileStatic"></app-owner-profile>
                    <div class="row margin-left-end ms-0 me-0">
                      <div class="col-md-2">
                        <button type="button" class="tu-button primary tu-shadow" (click)="addOwnerTab()">{{ 'content.add-owner' | translate }}</button>
                      </div>
                    </div>
                    <div class="d-flex justify-content-end inline-gap-5 submit-buttons margin-bottom-end me-1">
                      <button type="button" class="tu-button secondary tu-shadow" (click)="cancel()">{{ 'content.cancel' | translate }}</button>
                      <button class="tu-button primary tu-shadow" type="submit">{{ 'content.next' | translate }}</button>
                    </div>
                  </ng-template>
                </li>
                <!-- Additional Owner tabs -->
                @for (id of tabs; track id; let index = $index) {
                  <li role="tab" [ngbNavItem]="index">
                    <a ngbNavLink appAriaAttrsParent><div [ngClass]="ownerTabError[index] ? 'tab-error' : 'tab-custom'">{{ 'content.owner-tab' | translate }} {{ index + 2 }} </div></a>
                    <ng-template ngbNavContent>
                      <app-owner-profile formControlName="profile{{ index }}"></app-owner-profile>
                      <div class="row margin-left-end ms-0 me-0" #removeOwnerModalContainer>
                        <div class="col-md-2">
                          <button type="button" class="tu-button secondary tu-shadow" (click)="confirmRemoveOwnerTab(index, 'remove-owner-modal-label', removeOwnerModalContainer)">{{ 'content.remove-owner' | translate }}</button>
                        </div>
                        @if (index !== 3) {
                          <div class="col-md-2">
                            <button type="button" class="tu-button primary tu-shadow" (click)="addOwnerTab()">{{ 'content.add-owner' | translate }}</button>
                          </div>
                        }
                      </div>
                      <div class="d-flex justify-content-end inline-gap-5 submit-buttons margin-bottom-end me-1">
                        <button type="button" class="tu-button secondary tu-shadow" (click)="cancel()">{{ 'content.cancel' | translate }}</button>
                        <button class="tu-button primary tu-shadow" type="submit">{{ 'content.next' | translate }}</button>
                      </div>
                    </ng-template>
                  </li>
                }
              </ul>
              <div [ngbNavOutlet]="nav" class="mt-2"></div>
              <span id="remove-owner-modal-label" class="d-none">{{ 'aria.confirm-remove-owner-dialog' | translate }}</span>
            </div>
          }
        </form>
      </mat-step>
      <mat-step #step2 [completed]="false">
        <ng-template matStepLabel>{{ 'content.review' | translate }}</ng-template>
        <h2>{{ 'content.choose-service' | translate }}</h2>
        <div class="row">
          <div class="col-md-2 col-sm-4"><p class="mt-0 mb-0">{{ 'content.service' | translate }}:</p></div>
          <div class="col-md-4 col-sm-8"><p class="mt-0 mb-0">{{ v.serviceType }}</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.report-language' | translate }}:</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ i18nService.getTranslation('api.lang.full') | async }}</p></div>
        </div>
        <h2>{{ 'content.info-about-order' | translate }}</h2>
        <div class="row">
          <div class="col-md-2 col-sm-4"><p class="mt-0 mb-0">{{ 'content.product-type' | translate }}:</p></div>
          <div class="col-md-4 col-sm-8">
            @if (!!productTypes) {
              <div>
                @for (productType1 of productTypes; track productType1) {
                  <div>
                    @if (productType1.code === v.productType) {
                      <div>
                        <p class="mt-0 mb-0">{{ productType1.desc }}</p>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.reference-id' | translate }}:</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ reformatReferenceId(v.referenceId) }}</p></div>
          <div class="col-md-2 col-sm-4"><p class="mt-0 mb-0">{{ 'content.search-type' | translate }}:</p></div>
          <div class="col-md-4 col-sm-8">
            @if (!!searchTypes) {
              <div>
                @for (searchType1 of (searchTypes | keyvalue); track searchType1) {
                  <div>
                    @if (searchType1.key === v.searchType) {
                      <div>
                        <p class="mt-0 mb-0">{{ searchType1.value }}</p>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
          <!-- TODO: show selected addons -->
        </div>
        <h2>{{ 'content.business-report' | translate }}</h2>
        <h3>{{ 'content.business-name' | translate }}</h3>
        <div class="row">
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.business-operating-name' | translate }}:</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ v.businessOperatingName }}</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.business-legal-name' | translate }}:</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ v.businessLegalName }}</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.business-reg-num' | translate }}:</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ removeWhitespace(v.businessRegistrationNum) | uppercase }}</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.qualifier' | translate }}:</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ v.qualifier }}</p></div>
        </div>
        <h3 class="mt-2">{{ 'content.business-address' | translate }}</h3>
        <div class="row">
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.address.street-name' | translate }}:</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ v.streetName }}</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.address.city' | translate }}:</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ v.city }}</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.address.province' | translate }}:</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ v.province | uppercase}}</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.address.postal-code' | translate }}:</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ v.postalCode }}</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ 'content.business-phone' | translate }}:</p></div>
          <div class="col-md-3 col-sm-6"><p class="mt-0 mb-0">{{ v.businessTelephoneNumber }}</p></div>
        </div>
        <span id="submit-review-modal-label" class="d-none">{{ 'aria.confirm-submit-order-dialog' | translate }}</span>
        @if (!ownerTabEnabled) {
          <div>
            @if (!isNewOrder) {
              <div class="d-flex justify-content-end inline-gap-5 submit-buttons" #reviewModalContainer>
                <button class="tu-button secondary tu-shadow" type="button" (click)="back()">{{ 'content.back' | translate }}</button>
                <button class="tu-button primary tu-shadow" (click)="submitReview('submit-review-modal-label', reviewModalContainer)">{{ 'content.submit' | translate }}</button>
              </div>
            }
            @if (isNewOrder) {
              <div class="d-flex justify-content-end inline-gap-5 submit-buttons">
                <button class="tu-button secondary tu-shadow" type="button" (click)="back()">{{ 'content.back' | translate }}</button>
                <button class="tu-button primary tu-shadow" type="button" (click)="newOrder()">{{ 'content.new-order' | translate }}</button>
              </div>
            }
            @if (!!businessPicklistRows) {
              <div class="mt-2">
                <h2>{{ 'content.order-search-results' | translate }}</h2>
                @for (businessPickListRow of businessPicklistRows; track businessPickListRow) {
                  <app-business-search-result [bizInquiry]="bizInquiry" [business]="businessPickListRow"
                    [qualifier]="v.qualifier" [searchType]="v.searchType" [productDescription]="productDescription"
                  ></app-business-search-result>
                }
              </div>
            }
          </div>
        }
        @if (ownerTabEnabled) {
          <div class="mt-2">
            <div class="row margin-left-end ms-0 me-0 mt-2">
              <div class="col-md-3 ps-0">
                <button class="tu-button secondary tu-shadow" type="button" (click)="openBusinessTab()">{{ 'content.edit-business-info' | translate }}</button>
              </div>
            </div>
            <div>
              <h2>{{ 'content.owner-tab' | translate }}1</h2>
              <app-owner-confirm [profile]="p1"></app-owner-confirm>
              <div class="row margin-left-end ms-0 me-0 mt-2">
                <div class="col-md-3 ps-0">
                  <button class="tu-button secondary tu-shadow" type="button" (click)="openFirstOwnerTab()">{{ 'content.edit-first-owner-info' | translate }}</button>
                </div>
              </div>
            </div>
            @for (tab of tabs; track tab; let index = $index) {
              <div>
                <h2>{{ 'content.owner-tab' | translate }}{{ index+2 }}</h2>
                <app-owner-confirm [profile]="profileArray[index]"></app-owner-confirm>
                <div class="row margin-left-end ms-0 me-2">
                  <div class="col-md-3 ps-0">
                    <button class="tu-button secondary tu-shadow" type="button" (click)="openOwnerTab(index)">{{ editOwnerInfos.get(index.toString()) }}</button>
                  </div>
                </div>
              </div>
            }
            <div class="d-flex justify-content-end inline-gap-5 submit-buttons" #reviewModalContainer2>
              <button class="tu-button secondary tu-shadow" type="button" (click)="back()">{{ 'content.back' | translate }}</button>
              <button class="tu-button primary tu-shadow" (click)="submitReview('submit-review-modal-label', reviewModalContainer2)">{{ 'content.submit' | translate }}</button>
            </div>
          </div>
        }

      </mat-step>
    </mat-horizontal-stepper>
  </ng-template>

</app-sidenav>
